var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Helpers } from "survey-core";
import { ReactQuestionFactory } from "./reactquestion_factory";
import { SurveyElementBase } from "./reactquestion_element";
var TagboxFilterString = /** @class */ (function (_super) {
    __extends(TagboxFilterString, _super);
    function TagboxFilterString(props) {
        return _super.call(this, props) || this;
    }
    Object.defineProperty(TagboxFilterString.prototype, "model", {
        get: function () {
            return this.props.model;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TagboxFilterString.prototype, "question", {
        get: function () {
            return this.props.question;
        },
        enumerable: false,
        configurable: true
    });
    TagboxFilterString.prototype.componentDidUpdate = function (prevProps, prevState) {
        _super.prototype.componentDidUpdate.call(this, prevProps, prevState);
        this.updateDomElement();
    };
    TagboxFilterString.prototype.componentDidMount = function () {
        _super.prototype.componentDidMount.call(this);
        this.updateDomElement();
    };
    TagboxFilterString.prototype.updateDomElement = function () {
        if (!!this.inputElement) {
            var control = this.inputElement;
            var newValue = this.model.inputStringRendered;
            if (!Helpers.isTwoValueEquals(newValue, control.value, false, true, false)) {
                control.value = this.model.inputStringRendered;
            }
        }
    };
    TagboxFilterString.prototype.onChange = function (e) {
        var _a;
        var activeElement = (_a = e.target.getRootNode()) === null || _a === void 0 ? void 0 : _a.activeElement;
        if (e.target === activeElement) {
            this.model.inputStringRendered = e.target.value;
        }
    };
    TagboxFilterString.prototype.keyhandler = function (e) {
        this.model.inputKeyHandler(e);
    };
    TagboxFilterString.prototype.onBlur = function (e) {
        this.question.onBlur(e);
    };
    TagboxFilterString.prototype.onFocus = function (e) {
        this.question.onFocus(e);
    };
    TagboxFilterString.prototype.getStateElement = function () {
        return this.model;
    };
    TagboxFilterString.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: this.question.cssClasses.hint },
            this.model.showHintPrefix ?
                (React.createElement("div", { className: this.question.cssClasses.hintPrefix },
                    React.createElement("span", null, this.model.hintStringPrefix))) : null,
            React.createElement("div", { className: this.question.cssClasses.hintSuffixWrapper },
                this.model.showHintString ?
                    (React.createElement("div", { className: this.question.cssClasses.hintSuffix },
                        React.createElement("span", { style: { visibility: "hidden" }, "data-bind": "text: model.filterString" }, this.model.inputStringRendered),
                        React.createElement("span", null, this.model.hintStringSuffix))) : null,
                React.createElement("input", { type: "text", autoComplete: "off", id: this.question.getInputId(), inputMode: this.model.inputMode, ref: function (element) { return (_this.inputElement = element); }, className: this.question.cssClasses.filterStringInput, disabled: this.question.isInputReadOnly, readOnly: this.model.filterReadOnly ? true : undefined, size: !this.model.inputStringRendered ? 1 : undefined, role: this.model.ariaInputRole, "aria-required": this.model.ariaInputRequired, "aria-invalid": this.model.ariaInputInvalid, "aria-errormessage": this.model.ariaInputErrorMessage, "aria-expanded": this.model.ariaInputExpanded, "aria-label": this.model.ariaInputLabel, "aria-labelledby": this.model.ariaInputLabelledby, "aria-describedby": this.model.ariaInputDescribedby, "aria-controls": this.model.ariaInputControls, "aria-activedescendant": this.model.ariaInputActivedescendant, placeholder: this.model.filterStringPlaceholder, onKeyDown: function (e) { _this.keyhandler(e); }, onChange: function (e) { _this.onChange(e); }, onBlur: function (e) { _this.onBlur(e); }, onFocus: function (e) { _this.onFocus(e); } }))));
    };
    return TagboxFilterString;
}(SurveyElementBase));
export { TagboxFilterString };
ReactQuestionFactory.Instance.registerQuestion("sv-tagbox-filter", function (props) {
    return React.createElement(TagboxFilterString, props);
});
